import React from 'react';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import styled from 'styled-components';
import ProgramacaoHavanDateFilter from '../../Listagem/components/ProgramacaoHavanDateFilter';
import EmissaoProtocoloTable from './EmissaoProtocoloTable';
import { useEmissaoProtocolo, VISAO_PROTOCOLOS, VISAO_TODAS } from '../hooks/useEmissaoProtocolo';

const EmissaoProtocoloCard = () => {
  const {
    dateOptions,
    selectedDate,
    selectedDateOption,
    turnoAtivo,
    turnos,
    totais,
    visao,
    salvando,
    onSelectDate,
    onPreviousDate,
    onNextDate,
    onTurnoFilter,
    onRetryTurno,
    onVisao,
    onAlternarEtapa
  } = useEmissaoProtocolo();
  const soProtocolos = visao === VISAO_PROTOCOLOS;

  // As duas visões: o dia inteiro (quantos protocolos vão entrar) ou só os protocolos, para seguir a emissão.
  const botoesVisao = [
    { chave: VISAO_TODAS, rotulo: 'Ver todas as cargas do dia', icone: <ViewListOutlinedIcon style={{ fontSize: 16 }} />, ativo: !soProtocolos, onClick: () => onVisao(VISAO_TODAS) },
    { chave: VISAO_PROTOCOLOS, rotulo: 'Ver só as cargas com protocolo', icone: <ReceiptLongOutlinedIcon style={{ fontSize: 16 }} />, ativo: soProtocolos, onClick: () => onVisao(VISAO_PROTOCOLOS) }
  ];

  const renderTurno = (chaveTurno, titulo) => (
    <EmissaoProtocoloTable
      id={`emissao-protocolo-${chaveTurno}`}
      titulo={`${selectedDateOption.diaSemana} (${titulo})`}
      chaveDados={`${selectedDate || ''}:${visao}`}
      data={turnos[chaveTurno].registros}
      carregando={turnos[chaveTurno].carregando}
      erro={turnos[chaveTurno].erro}
      onRetry={() => onRetryTurno(chaveTurno)}
      salvando={salvando}
      onAlternarEtapa={onAlternarEtapa}
      mensagemVazia={soProtocolos ? 'Nenhuma carga marcada como protocolo neste turno ainda.' : 'Nenhuma carga programada neste turno.'}
    />
  );

  return (
    <Card>
      <CardBody>
        <Cabecalho>
          <CardTitle className="mb-0">Emissão de protocolo</CardTitle>
          <CardSubhead>
            {selectedDateOption.label ? `${selectedDateOption.label}: ` : ''}
            <strong data-testid="total-protocolos">{totais.protocolos} protocolo(s)</strong> em {totais.cargas} carga(s) programada(s).
            {' '}{soProtocolos ? 'Mostrando só os protocolos.' : 'Mostrando todas as cargas; as cinzas ainda não têm protocolo.'}
          </CardSubhead>
        </Cabecalho>
        <ProgramacaoHavanDateFilter
          dateOptions={dateOptions}
          selectedDate={selectedDate}
          turnoAtivo={turnoAtivo}
          onSelectDate={onSelectDate}
          onPreviousDate={onPreviousDate}
          onNextDate={onNextDate}
          onTurnoFilter={onTurnoFilter}
          botoesExtras={botoesVisao}
        />
        {turnoAtivo !== 'segundo' ? renderTurno('primeiro', 'PRIMEIRO TURNO') : null}
        {turnoAtivo !== 'primeiro' ? renderTurno('segundo', 'SEGUNDO TURNO') : null}
      </CardBody>
    </Card>
  );
};

export default EmissaoProtocoloCard;

const Cabecalho = styled.div`margin-bottom: 14px;`;
